module.exports = __webpack_public_path__ + "img/logboek.d0e61b9d.png";